import axios from 'axios'

export default {
  getFbId(payload, params) {
    return axios.get('/facebook/fbid/'+payload.url, {
      params
    })
  }
}
